import * as React from 'react';

import { ErrorBoundary } from 'bernie-view';

import { HotelViewModel } from 'models';

import { UitkCardMedia } from 'uitk-react-cards';
import { UitkQueuedImage } from 'uitk-react-images';

export interface ListingErrorBoundaryProps {
  thumbnail: HotelViewModel['thumbnail'];
  name: string;
}

export const ListingErrorBoundary: React.FunctionComponent<ListingErrorBoundaryProps> = ({ thumbnail, name, ...rest }) => {
  const innerH3ClassNames = [
    'uitk-cell',
    'all-cell-align-bottom',
    'uitk-type-500',
    'uitk-type-medium',
    'pwa-theme--color-white',
    'truncate',
  ];

  return (
    <ErrorBoundary
      label="hotel.search.listing.title"
      fallback={
        <header className="listing__title title">
          <UitkCardMedia>
            <UitkQueuedImage className="uitk-grid image-loader" src={(thumbnail && thumbnail.src) || ''} useBackgroundImage={true}>
              <h3 className={innerH3ClassNames.join(' ')} data-stid="content-hotel-title">
                {name}
              </h3>
            </UitkQueuedImage>
          </UitkCardMedia>
        </header>
      }
      {...rest}
    />
  );
};
